import request from '@/tool/http'

// 首页平台模块查询
export function getSubSystemList() {
    return request({
      url: '/subSystem/list.html',
      method: 'get'
    })
}
// 首页平台模块查询
export function getUuid() {
    return request({
      url: '/getUuid.html',
      method: 'post'
    })
}

// 查询公共信息
export function getMessage(params) {
    return request({
      url: '/info/toFindProperty.html',
      method: 'get',
	    params: params,
    })
}

export function getUrl(params) {
    return request({
      url: '/mini/URLScheme.html',
      method: 'get',
	    params: params,
    })
}
